import { z } from "zod/v4";

export const DisableIntegrationRequestPathParamSchema = z.object({
  id: z.uuid(),
});

export type DisableIntegrationRequestPathParamType = z.infer<
  typeof DisableIntegrationRequestPathParamSchema
>;

export const DisableIntegrationResponseBodySchema = z.string();

export type DisableIntegrationResponseBodyType = z.infer<
  typeof DisableIntegrationResponseBodySchema
>;
